import { initDataLayer, isBrowser, persistTrackingData } from '../util';
export function pushHotelDetails(staticDetails) {
    var _a;
    if (!isBrowser())
        return;
    initDataLayer();
    const { name, geography, estabId, attributeGroups, starRating } = staticDetails;
    const facilities = (_a = attributeGroups === null || attributeGroups === void 0 ? void 0 : attributeGroups.find((ag) => ag.type === 1)) === null || _a === void 0 ? void 0 : _a.attributes.map((attribute) => attribute.name);
    const selectedHotel = {
        name,
        location: geography === null || geography === void 0 ? void 0 : geography.location,
        province: geography === null || geography === void 0 ? void 0 : geography.province,
        country: geography === null || geography === void 0 ? void 0 : geography.country,
        estabId,
        facilities,
        starRating,
    };
    window.dataLayer.push({ selectedHotel });
    persistTrackingData({ selectedHotel });
}
